var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColombiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.9922V19.984H30L29.9999 14.9922H0Z",
    fill: "#FF4B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0002V0.0166016H30L29.9999 10.0002H0Z",
    fill: "#FFE15A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 10H0V14.9917H29.9999V10Z",
    fill: "#41479B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColombiaFlag);
export default __webpack_public_path__ + "static/media/colombiaFlag.b9fe10f906380442dcfb705807da7407.svg";
export { ForwardRef as ReactComponent };